import { addLayerExist, removerLayerExist } from '../layerStatusControl'

const singeHeightLayer = {}

function addSingeHeightLayer (params, viewer) {
  const id = params.id
  // const viewer = self.viewer
  // const extent = params.extent || [-110.0, 20.0, -80.0, 25.0]
  // const _url = params.url || ''
  // const _height = params.height || 0

  const info = getaddSingeHeightLayerInfo(params)
  // 高度数据
  var heightLayer = viewer.entities.add(info)

  // 存在状态设置
  singeHeightLayer[id] = heightLayer

  const addInfo = {
    info: params,
    layer: null,
    market: heightLayer
  }
  addLayerExist(addInfo)
  return heightLayer
}

function getaddSingeHeightLayerInfo (params) {
  const id = params.id
  const _extent = params.extent || [-110.0, 20.0, -80.0, 25.0]
  const _height = params.height || 0
  const _url = params.url || ''
  const _material = new Cesium.ImageMaterialProperty({
    image: _url,
    transparent: true
  })
  let info = {
    name: 'height layer' + id,
    rectangle: {
      coordinates: Cesium.Rectangle.fromDegrees(
        _extent[0], _extent[1], _extent[2], _extent[3]),
      material: _material,
      height: _height
    }
  }

  // 判断 范围
  if (_extent === [-180.0, -90.0, 180.0, 90.0]) {
    var mantleRadius = 6300000.0
    const innerCoreRadius = mantleRadius + _height
    info = {
      name: 'height layer global' + id,
      position: Cesium.Cartesian3.ZERO,
      ellipsoid: {
        radii: new Cesium.Cartesian3(
          innerCoreRadius,
          innerCoreRadius,
          innerCoreRadius
        ),
        material: _material
      }
    }
  }
  return info
}

function removeSingeHeightLayer (layerInfo, viewer) {
  const _id = layerInfo.id
  if (singeHeightLayer[_id]) {
    const stationItem = singeHeightLayer[_id]
    viewer.entities.remove(stationItem)
    singeHeightLayer[_id] = null
    removerLayerExist(layerInfo)
    return true
  }
  return false
}

export {
  addSingeHeightLayer,
  removeSingeHeightLayer
}
